import { render, staticRenderFns } from "./WarnSection.vue?vue&type=template&id=01cc6b03&"
import script from "./WarnSection.vue?vue&type=script&lang=js&"
export * from "./WarnSection.vue?vue&type=script&lang=js&"
import style0 from "./WarnSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports